export default __webpack_public_path__ + "images/WG.b43ca9f.png";